import { Component, Input, OnInit } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CmsTarget } from '@fcom/core-api';

import { toLinkData } from '../../services';

@Component({
  selector: 'cms-cta-link',
  template: `
    <fin-cta-big-link
      [target$]="cmsTarget$"
      [teaserTitle$]="content$ | finMap: 'teaserTitle'"
      [teaserText$]="content$ | finMap: 'teaserText'"
      [layout]="'small'"
      class="mr-small-t mr-xxsmall-b"
    >
    </fin-cta-big-link>
  `,
})
export class CmsCtaLinkComponent implements OnInit {
  @Input()
  content$: Observable<any>;

  cmsTarget$: Observable<CmsTarget>;

  ngOnInit(): void {
    this.cmsTarget$ = this.content$.pipe(map((d) => toLinkData(d.target)));
  }
}
